import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ArrowBigDown = createReactComponent("ArrowBigDown", ["svg", defaultAttributes, [["path", {
  d: "M9 3h6v11h4l-7 7-7-7h4z",
  key: "9v4vit"
}]]]);
export default ArrowBigDown;